import type { FulfilledResponse, RequestFn, RequestOptions, ResolvedRequestOptions } from '../types';

type InterceptorFn = <Response>(
    request: RequestFn,
    // eslint-disable-next-line @typescript-eslint/no-explicit-any -- DIRECT-239681
    requestOptions: RequestOptions<Response, any>,
    // eslint-disable-next-line @typescript-eslint/no-explicit-any -- DIRECT-239681
    resolvedRequestOptions: ResolvedRequestOptions<Response, any>
) => Promise<FulfilledResponse<Response>> | undefined;

let installedInterceptor: InterceptorFn | undefined;

/**
 * Вызывает обработчик для всех запросов, выполняемых через modules-request, если
 * ранее он был установлен через installInterceptor(). Хранение обработчика в переменной
 * позволяет не добавлять в production бандл лишний код для обработки моков.
 *
 * @param request Функция, через которую выполняются запросы
 * @param requestOptions Параметры запроса
 * @param resolvedRequestOptions Параметры запроса, склеенные с initial опциями
 * @returns Замоканый ответ, если найден мок для запроса
 */
export function mocksInterceptor<Response>(
    request: RequestFn,
    // eslint-disable-next-line @typescript-eslint/no-explicit-any -- DIRECT-239681
    requestOptions: RequestOptions<Response, any>,
    // eslint-disable-next-line @typescript-eslint/no-explicit-any -- DIRECT-239681
    resolvedRequestOptions: ResolvedRequestOptions<Response, any>
) {
    return installedInterceptor?.<Response>(request, requestOptions, resolvedRequestOptions);
}

/**
 * Добавляет обработчик для всех запросов, выполняемых через modules-request.
 * @param fn Обработчик
 */
export function installInterceptor(fn: InterceptorFn) {
    installedInterceptor = fn;
}
